import { ModelHelper } from '../classes/model-helper';
import { ListFilter } from '../interfaces/list-filter.interface';
import { ResponseProperties } from '../interfaces/response-properties.interface';

/**
 * Object to configure list requests
 */
export class ListRequest {
	/**
	 * Id of result in the response object
	 */
	id: string;

	/**
	 * Configuration for list filter, sort and pagination
	 */
	filter?: ListFilter;

	/**
	 * Requested properties
	 */
	properties: (string | ResponseProperties)[] = ['displayName', 'name', 'uid'];

	/**
	 * Query name
	 */
	query?: string;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns ListRequest
	 */
	public static map(data: any, item: ListRequest = new ListRequest()): ListRequest {
		return item.map(data);
	}

	/**
	 * Convert properties to string
	 *
	 * @param properties
	 */
	public static getPropertyString(properties: (string | ResponseProperties)[]): string {
		let response = '';

		if (!Array.isArray(properties)) {
			return response;
		}

		properties.forEach((item) => {
			if (typeof item === 'string') {
				response += item + ' ';
			} else {
				response += `${item.id} {
					${this.getPropertyString(item.properties)}
				}`;
			}
		});
		return response;
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return ListRequest
	 */
	public map(data: any): ListRequest {
		ModelHelper.map(data, this, 'id');
		ModelHelper.map(data, this, 'query');
		ModelHelper.map(data, this, 'filter');
		ModelHelper.map(data, this, 'properties');

		return this;
	}

	/**
	 * Convert properties to string
	 *
	 * @param properties
	 */
	public getPropertyString(properties: (string | ResponseProperties)[] = this.properties): string {
		return ListRequest.getPropertyString(properties);
	}
}
